import React, { useEffect, useState } from 'react';
import HamQuest from '../../api/HamQuestGiver';
import { QuestRoute } from '../../api/QuestRoutes';
import { useParams } from 'react-router-dom';
import { INVALID_DATE_STRING, generateId, shortHandDateTime, shortHandDateTimeUTC, translate, uniqueSet } from '../../utility/functions';
import Col from '../../layout/Col';
import Table from '../../table/Table';
import Row from '../../layout/Row';
import Icon from '../../forms/Icon';
import Modal from '../../Modal';

const Audit = ({ children, customerId, ...props }) => {
    const { guid } = useParams();
    const [data, setData] = useState(null);

    const AuditType = {
        system: 'System|m',
        order: 'Order',
        orderedProduct: 'OrderedProduct',
        merchant: 'm',
    }

    useEffect(() => {
        HamQuest.get(QuestRoute.user.audit(guid || customerId))
            .then(res => {
                res
                    .filter(e => !/Attempted Insert|Failed Insert/.test(e.entityAction))
                    .forEach(e => {
                        if (!e.details) return;
                        try {
                            e.details = JSON.parse(e.details);

                            const changes = (
                                e.details.Changes ||
                                Object.entries(e.details.ColumnValues)
                                    .map(([ColumnName, NewValue]) => ({ ColumnName, NewValue, OriginalValue: null }))
                            )
                                .filter(f => f.NewValue !== f.OriginalValue && !/ConcurrencyStamp|LastLoginDate/.test(f.ColumnName));

                            const user = (e.userName || AuditType.system).split('|');

                            const audit = {
                                user: user[0],
                                userType: user[1],
                                changes,
                                date: e.logTimeUtc,
                                entity: translateAudit(e.entityName),
                                action: translateAudit(e.entityAction),
                                isOrder: e.entityName === AuditType.order,
                                orders: res.filter(f => e.invoiceId === f.invoiceId && f.entityName === AuditType.orderedProduct).map(f => f.details.ColumnValues),
                            };

                            e.goodAudit = !(changes.length === 0 || e.entityName === AuditType.orderedProduct)
                            e.audit = audit;
                        } catch (ex) {
                            console.error(ex, e);
                        }
                    });

                setData(res.filter(e => e.goodAudit).map(e => e.audit))
            })
    }, [])

    const representValues = (key, value) => {
        if (key.match(/date|time/gi)) {
            const temp = value;
            value = shortHandDateTime(temp);
            if (value.includes(INVALID_DATE_STRING))
                value = temp;
        }
        if (key.match(/password|tag/gi)) {
            value = '********'
        }

        return translate(value)
    }

    const addSpaces = e => e.replace(/([a-z])([A-Z])/g, '$1 $2');

    const UserTypeIcon = ({ type }) => <Icon title={type === AuditType.merchant ? 'Merchant' : 'User'} icon={type === AuditType.merchant ? 'wrench' : 'user'} />

    const tableConfig = {
        data: data,
        colSpacing: [18, 9, 9, 14, 25, 0, 25],
        sticky: true,
        headers: [
            {
                label: 'User',
                propKey: 'user',
                options: data => uniqueSet(data.map(e => e.user))
            }, {
                label: 'Has',
                propKey: 'action',
                options: data => uniqueSet(data.map(e => e.action))
            }, {
                label: 'Their',
                propKey: 'entity',
                options: data => uniqueSet(data.map(e => translateAudit(e.entity)))
            }, {
                label: 'At',
                propKey: 'date',
                type: 'date'
            }, {
                label: 'From (Old Value)',
            }, {
                label: '',
            }, {
                label: 'To (New Value)',
            }
        ],
        renderFormat: (audit) => {
            const { user,
                userType,
                date,
                entity,
                action,
                changes,
                isOrder,
                orders
            } = audit

            return (
                <tr
                    key={generateId()}
                    // onClick={() => modalView(audit)}
                    title={`The user has ${translateAudit(action)} their ${changes.map(e => addSpaces(e.ColumnName)).join(', ')} at ${shortHandDateTime(date)}`}
                >
                    <td>
                        <Row><UserTypeIcon type={userType} />{user}</Row>
                    </td>
                    <td>{action}</td>
                    <td>{entity}</td>
                    <td>{shortHandDateTimeUTC(date)}</td>
                    <td>
                        <Col>
                            {changes.map(e => e.OriginalValue ? (
                                <Row key={generateId()}>
                                    <b>{addSpaces(e.ColumnName)}</b>:
                                    <span>{representValues(e.ColumnName, e.OriginalValue)}</span>
                                </Row>
                            ) : null)}
                        </Col>
                    </td>
                    <td><Icon icon='arrowRight' /></td>
                    <td>
                        <Col>
                            {changes.map(e => (
                                <Row key={generateId()}>
                                    <b>{addSpaces(e.ColumnName)}</b>:
                                    <span>{representValues(e.ColumnName, e.NewValue)}</span>
                                </Row>
                            ))}
                            {isOrder && orders.map(e => (
                                <Row key={generateId()}>
                                    <b>Ordered Product</b>: <span>{e.Name}</span>
                                </Row>
                            ))}
                        </Col>
                    </td>
                </tr>
            )
        }
    }

    return <Table config={tableConfig} />;
}

export default Audit;

const translateAudit = (word) => {
    const glossary = {
        Update: 'Updated',
        Insert: 'Created',
        Delete: 'Deleted',
        AppUser: 'User Account',
        ApplicationUser: 'User Account',
        AppUserVehicle: 'Vehicle',
        LoyaltyAccount: 'Loyalty Account',
        AppUserPointTransaction: 'App Point',
        LoyaltyTransaction: 'Loyalty Transaction',
        AppUserAward: 'App Award',
        AppUserProduct: 'App Product',
        InvoiceCardResult: 'Invoice Card Result',
        InvoiceLineItem: 'Invoice Item',
        LoyaltyAccountCctag: 'Card on File',
    }

    return glossary[word] || word
}
